import type { PriceRangeInterval } from '@typings/search';
import classNames from 'classnames';
import React from 'react';
import Styles from './BarChart.scss';

interface BarStyle extends React.CSSProperties {
	'--bar-height': string;
}

interface BarChartProps {
	intervals: PriceRangeInterval[];
	minVal: number;
	maxVal: number;
}

export const BarChart = ({ intervals, minVal, maxVal }: BarChartProps) => {
	if (intervals.length === 0) return null;

	const maxIntervalValue = Math.max(...intervals.map((i) => i.total));

	return (
		<div
			className={Styles.barChart}
			data-count={intervals.reduce((sum, i) => sum + i.total, 0)}
		>
			{intervals.map(({ range, total }) => {
				const isInRange =
					range.from <= maxVal && (range.to === null || range.to > minVal);
				const barHeight =
					maxIntervalValue > 0 ? (total / maxIntervalValue) * 100 : 0;
				const barStyle: BarStyle = { '--bar-height': `${barHeight}%` };

				return (
					<div
						key={`bar-${range.from}`}
						data-range={`${range.from}-${range.to ?? 'UP'}`}
						data-quantity={total}
						className={classNames(Styles.bar, {
							[Styles.barActive]: isInRange,
						})}
						style={barStyle}
					/>
				);
			})}
		</div>
	);
};
